/** Pick first non-empty trimmed string. */
export function pickNonEmptyStr(...vals: unknown[]): string | null {
  for (const v of vals) {
    if (v == null) continue
    const s = String(v).trim()
    if (s) return s
  }
  return null
}

export function formatTelegramUsername(username: string | null | undefined): string | null {
  const u = username?.trim()
  if (!u) return null
  return u.startsWith('@') ? u : `@${u}`
}

export type TelegramVisitorNameParts = {
  /** Name from contact form / contact.name (same source as email). */
  contactFormName?: string | null
  firstName?: string | null
  lastName?: string | null
  username?: string | null
  /** Optional profile / user link from API when username is missing. */
  userLink?: string | null
  /** Telegram user / chat id — last resort. */
  userId?: string | null
}

/**
 * Display label for a Telegram visitor.
 * Priority: contact form name → firstName → lastName → @username → userLink → userId
 */
export function resolveTelegramVisitorName(parts: TelegramVisitorNameParts): string | null {
  return pickNonEmptyStr(
    parts.contactFormName,
    parts.firstName,
    parts.lastName,
    formatTelegramUsername(parts.username),
    parts.userLink,
    parts.userId,
  )
}
